import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove any prerendered SEO shell sibling before mounting React so it can't
// interfere with React's DOM management (which caused removeChild errors).
document.querySelectorAll("[data-prerender-shell]").forEach((el) => el.remove());

createRoot(document.getElementById("root")!).render(<App />);
